export function isInStoryblokEditor() {
  return typeof window !== 'undefined' && window.location !== window.parent.location;
}
